<div class="faq-landing">
  <div class="faq-landing__banner">
    <div class="faq-landing__banner-title">
      <h2 i18n="@@CUSTOMER_SERVICE">Customer service</h2>
    </div>
    <div class="faq-landing__banner-img">
      <img alt="Hero Banner" [src]="'assets/images/faq-banner.jpg' | staticFileHash" />
    </div>
  </div>

  <div class="faq-landing__topics">
    <div class="container">
      <h3>{{ FAQLandingContent?.title }}</h3>

      <div>
        <ul>
          @for (topic of FAQLandingContent?.topics; track topic; let i = $index) {
            <li tabindex="0" (click)="topicSelection(topic)" (keyup)="topicSelection(topic)">
              <div class="faq-landing__topic-wrapper" [ngClass]="topic.isActive ? 'active' : ''">
                <div class="faq-landing__topic-img">
                  <img
                    [src]="topic.isHovered ? topic.topicHoverIcon : topic.topicIcon"
                    alt="{{ topic.title }}"
                    (mouseenter)="onTopicHover(topic)"
                    (mouseleave)="onTopicLeave()"
                  />
                </div>
                <div class="faq-landing__topic-title">
                  <h4>{{ topic.title }}</h4>
                </div>
                <div class="faq-landing__topic-link d-none d-md-block">
                  <button
                    class="faq-more-info"
                    type="button"
                    (click)="topicSelection(topic)"
                    (keyup)="topicSelection(topic)"
                    i18n="@@LEARN_MORE"
                  >
                    More info
                  </button>
                </div>
                <i class="fal fa-chevron-right d-block d-md-none"></i>
              </div>
            </li>
          }
        </ul>

        <!-- <div class="faq-landing__search">
        <label for="searchText" i18n="@@contentful.supportSearch">Support Search</label>
        <div>
          <form novalidate="" action="" class="faq-landing__search-form" role="search">
            <label class="faq-landing__search-title" for="searchText"></label>
            <div class="faq-landing__search-bar">
              <input id="searchText" type="text" autocomplete="on" value="">
              <button type="submit" class="faq-landing__search-icon">
                <i class="fas fa-magnifying-glass"></i>
                <div class="sr-only" i18n="@@SEARCH">Search</div>
              </button>
            </div>
          </form>
        </div>
      </div> -->
      </div>
    </div>
  </div>

  <div class="faq-landing__qa" id="faq-landing__content">
    <div class="faq-landing__qa-block container">
      <div class="faq-landing__qa-title">
        <h2>{{ activeTopic.title }}</h2>
      </div>
      <ul class="faq-landing__qa-list">
        @for (faq of activeTopic.faqs; track faq) {
          <li class="faq-landing__qa-li">
            <div class="faq-landing__qa-wrapper">
              <i class="fal fa-arrow-right"></i>
              <h3
                class="faq-landing__block__question-text"
                tabindex="0"
                (click)="redirectToFAQ(faq.id)"
                (keyup)="redirectToFAQ(faq.id)"
              >
                {{ faq.question }}
              </h3>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
